var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isPc)?_c('PcPage'):_c('MobilePage')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }